import { useTranslation } from "react-i18next";

import {
  Badge,
  Box,
  Card,
  Center,
  Divider,
  Group,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconCalendarHeart } from "@tabler/icons-react";

import AvailabilityCalendar from "@/components/availability-calendar/availability-calendar";
import BookingButton from "@/components/booking-button/booking-button";
import { bookingOptions } from "@/constants";

export function BookingPage() {
  const { t } = useTranslation();

  return (
    <Stack gap="xl" maw={960} mx="auto">
      <Stack gap="sm" align="center" ta="center">
        <Badge
          size="lg"
          radius="sm"
          color="sea"
          variant="light"
          leftSection={<IconCalendarHeart size={14} />}
        >
          {t("menu.book")}
        </Badge>
        <Title order={1}>{t("bookingPage.title")}</Title>
        <Text size="md" c="dimmed" maw={680}>
          {t("bookingPage.paragraph")}
        </Text>
      </Stack>

      <Card withBorder p={{ base: "md", sm: "xl" }}>
        <Center>
          <Box w="100%" maw={520}>
            <AvailabilityCalendar />
          </Box>
        </Center>
      </Card>

      <Stack gap="md" align="center">
        <Divider w="60%" label="OR" labelPosition="center" />
        <Title order={4} ta="center">
          {t("bookingPage.alt")}
        </Title>
        <Group justify="center" gap="md">
          <BookingButton bookingOption={bookingOptions.airbnb} />
          <BookingButton bookingOption={bookingOptions.bookingcom} />
        </Group>
      </Stack>
    </Stack>
  );
}

export default BookingPage;
